import store from '../store';
import * as cartTypes from '../types/carttypes';
// import httpClient from '../../services/http';
// import { encryptStorage } from '../../utils/storage';
// import { APIUtils } from '../../utils/apiutils';

const dispatch = store.dispatch;

export const addToCart = (cartItem) => {
    dispatch({ type: cartTypes.ADD_TO_CART, payload: cartItem });
};
export const removeFromCart = (cartItemIndex) => {
    dispatch({ type: cartTypes.REMOVE_FROM_CART, payload: cartItemIndex });
};
export const updateCartOrderInfo = (orderInfo) => {
    dispatch({ type: cartTypes.UPDATE_CART_ORDER_INFO, payload: orderInfo });
};
export const emptyCart = () => {
    dispatch({ type: cartTypes.EMPTY_CART });
};